<div class="dialog-container">
  <form [formGroup]="form">
    @if (showFeature().synthVoice) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="synthVoice" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.synthVoice.disabled">Escuchar Voz</span>
        <br />
        <small>Desmarca si solo quieres leer texto</small>
      </p>
    </div>
    } @if (showFeature().highlightWords) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="highlightWords" [binary]="true" inputId="binary"></p-checkbox>
        <span>Narración de texto</span>
        <br />
        <small>Remarca las palabras como se van pronuncionando</small>
      </p>
    </div>
    } @if (showFeature().speed) {
    <div class="settings-section">
      <p>
        Velocidad ({{ form.controls.speed.value | speedDisplay }})
        <br />

        <!-- <p-rating formControlName="speed" iconOnClass="pi pi-step-forward" iconOffClass="pi pi-minus" /> -->

        <p-select
          id="speed"
          [options]="speedOptions"
          formControlName="speed"
          [placeholder]="'Select Language'"
          optionLabel="label"
          optionValue="value"></p-select>
      </p>
    </div>
    } @if (showFeature().realTime) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="realTime" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.realTime.disabled">Tiempo real</span>
        <br />
        <small>No tienes que presionar el microphono, comenzará a grabar en cuanto la AI termine de hablar, cierra el chat para finalizar conversación.</small>
      </p>
    </div>
    } @if (showFeature().realTime) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="repeatRecording" [binary]="true" inputId="binary"></p-checkbox>
        <span>Reproducir mi grabación</span>
        <br />
        <small>Escucha tu dialogo, después de grabar, te ayudará a notar tus errores.</small>
      </p>
    </div>
    } @if (showFeature().superHearing) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="superHearing" [binary]="true" inputId="binary"></p-checkbox>
        <span>Super Oído 🦾</span>
        <br />
        <small>Tu audio se procesa en el servidor para mejor efectividad, si no usa el navegador.</small>
      </p>
    </div>
    }

    <!-- @if (showFeature().fixGrammar) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="fixGrammar" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.fixGrammar.disabled">Corregir gramática</span>
        <br />
        <small>La ai corrige tu forma de hablar/escribir y te retrolimenta de tus errores</small>
      </p>
    </div>
    }  -->

    <!-- @if (showFeature().autoTranslate) {
    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="autoTranslate" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.autoTranslate.disabled">Mostrar Traducciones </span>
        <br />
        <small>Texto adicional con la traducción</small>
      </p>
    </div>
    }  -->

    @if (showFeature().autoTranslate) {
    <div class="voice-selection">
      <span>Voz Preferencial:</span>
      <br />
      <p-radioButton value="random" formControlName="voice"></p-radioButton>
      <label class="space">Aleatorio</label>
      <p-radioButton value="randomMan" formControlName="voice"></p-radioButton>
      <label class="space">Hombre</label>
      <p-radioButton value="randomWoman" formControlName="voice"></p-radioButton>
      <label class="space">Mujer</label>
    </div>
    }

    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="userMessageTask" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.userMessageTask.disabled">Procesar mensajes de usuario</span>
        <br />
        <small>Correcciones, mejoras, retroalimentación y sugerencias en el texto del usuario </small>
      </p>
    </div>

    <div class="settings-section">
      <p>
        <p-checkbox class="mr-2" formControlName="assistantMessageTask" [binary]="true" inputId="binary"></p-checkbox>
        <span [class.cross]="form.controls.assistantMessageTask.disabled">Procesar mensajes de asistente</span>
        <br />
        <small>Correcciones, traducciones, pensamientos adicionales y más ayuda en el texto del asistente </small>
      </p>
    </div>

    @if(isAdmin) {
    <div>
      <hr />
      <b>Admin Section</b>
      <br />

      <b>Modelo:</b>

      <dc-model-selector [modelForm]="form.controls.model"></dc-model-selector>
    </div>
    }

    <div class="button-group">
      <p-button (click)="saveSettings()" label="Guardar cambios"></p-button>
      <p-button (click)="close()" label="Cancelar" styleClass="p-button-secondary"></p-button>
    </div>
  </form>
</div>
